import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { BigScreenHeader } from './BigScreenHeader';
import { SmallScreenHeader } from './SmallScreenHeader';
const STEPS = ['ABOUT YOURSELF', 'ABOUT ORGANIZATION', 'GRANT SEARCH', 'REVIEW GRANTS'];
export const StepperHeader = ({ step }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    return (React.createElement(Box, { width: "100%", maxWidth: "880px" },
        isSmallScreen && React.createElement(SmallScreenHeader, { step: step, currentStepLabel: STEPS[step] }),
        !isSmallScreen && React.createElement(BigScreenHeader, { step: step, stepLabels: STEPS })));
};
